import { useCallback } from 'react';
import { useToggle } from 'react-use';

import { useRefetchMedicalServices } from '../shared/queries/useRefetchMedicalServices';

import { MedicalServiceUpdateModal } from './MedicalServiceUpdateModal';

type MedicalServiceUpdateModalOpenerRenderProps = { openModal: VoidFunction };

type MedicalServiceUpdateModalOpenerProps = {
   readonly medicalServiceId: number;
   readonly children: (renderProps: MedicalServiceUpdateModalOpenerRenderProps) => JSX.Element;
};

export const MedicalServiceUpdateModalOpener = (props: MedicalServiceUpdateModalOpenerProps): JSX.Element => {
   const refetchMedicalServices = useRefetchMedicalServices();
   const [modalOpened, toggleModalOpened] = useToggle(false);

   const openModal = useCallback(() => {
      toggleModalOpened(true);
   }, [toggleModalOpened]);

   const handleSuccess = useCallback(() => {
      toggleModalOpened(false);
      refetchMedicalServices();
   }, [refetchMedicalServices, toggleModalOpened]);

   return (
      <>
         {props.children({
            openModal: openModal,
         })}
         {modalOpened ? (
            <MedicalServiceUpdateModal
               medicalServiceId={props.medicalServiceId}
               onSuccess={handleSuccess}
               closeModal={toggleModalOpened}
            />
         ) : null}
      </>
   );
};
